import { Navigate } from "react-router-dom";
import useSupportSessionGuard from "../hooks/useSupportSessionGuard";

export default function SupportAgentRoute({ children }) {
  const { checking, supportUser } = useSupportSessionGuard();

  if (checking) {
    return <div className="min-h-screen bg-[#171717]" />;
  }

  if (!supportUser?.id) {
    return <Navigate to="/u/support/agent/login" replace />;
  }

  if (supportUser.mustChangePassword) {
    return <Navigate to="/u/support/settings" replace />;
  }

  const rawRole = String(supportUser.role || "").toLowerCase();
  if (supportUser.isSuperAdmin || rawRole === "superadmin") {
    return <Navigate to="/u/admin" replace />;
  }
  if (["admin", "lead"].includes(rawRole)) {
    return <Navigate to="/u/support/admin" replace />;
  }
  const normalizedRole = rawRole.includes("support") ? "support" : rawRole;
  if (normalizedRole !== "support") {
    return <Navigate to="/u/support/agent/login" replace />;
  }

  return children;
}
